import Dbm from "dbm";
import Website from "../index.js";
import { graphapi } from "../library.js";

export {default as GameHolder} from "./GameHolder.js";
export {default as GameContentBlock} from "./GameContentBlock.js";
export {default as Game} from "./Game.js";
export {default as Timer} from "./Timer.js";

export * as PhysicsGroups from "./PhysicsGroups.js";
export * as Sizes from "./Sizes.js";

export * as gameplay from "./gameplay/index.js";
export * as screens from "./screens/index.js";
export * as assets from "./assets/index.js";
export * as graphics from "./graphics/index.js";

export const createAssetObject = function(aName) {
    let currentObject = new Website.game.assets.AssetObject();
    currentObject.item.register("game/assets/" + aName);
    currentObject.item.setValue("assetsFolder", build.assetsPath + "img/game/" + aName);

    return currentObject;
}

export const getAsset = function(aName) {
    return Dbm.getRepositoryItemIfExists("game/assets/" + aName);
}

export const getAssetAnimation = function(aName, aPart) {
    let animationPart = Dbm.getRepositoryItemIfExists("game/assets/" + aName + "/" + aPart);
    if(!animationPart) {
        console.warn("No animation", aName, aPart, "game/assets/" + aName + "/" + aPart);
    }

    return animationPart;
}

export const getTextures = function(aName, aPart) {
    let currentAnimation = getAssetAnimation(aName, aPart);

    if(!currentAnimation) {
        console.error("Graphics no found", aName, aPart);
        return [];
    }

    return currentAnimation.textures;
}

export const getSprite = function(aName, aPart, aIndex = 0) {
    let texture = getTextures(aName, aPart)[aIndex];
    let sprite = new PIXI.Sprite(texture);
    sprite.anchor.set(0.5, 1);
    
    return sprite;
}

export const getAnimatedSprite = function(aName, aPart, aAnimationSpeed = 0.15) {
    let textures = getTextures(aName, aPart);
    let sprite = new PIXI.AnimatedSprite(textures);
    sprite.anchor.set(0.5, 1);
    sprite.animationSpeed = aAnimationSpeed;
    
    return sprite;
}

export const getAnimatedSpriteWithOrder = function(aName, aPart, aOrder, aAnimationSpeed = 0.15) {
    let textures = getTextures(aName, aPart);

    let orderTextures = Dbm.utils.ArrayFunctions.getInOrder(textures, aOrder);

    let sprite = new PIXI.AnimatedSprite(orderTextures);
    sprite.anchor.set(0.5, 1);
    sprite.animationSpeed = aAnimationSpeed;
    
    return sprite;
}

export const getButton = function(aName = "screens/button", aPart = "main", aIndex = 0, aMargin = 5) {
    let texture = getTextures(aName, aPart)[aIndex];
    let sprite = new PIXI.NineSliceSprite({
        texture,
        leftWidth: aMargin,
        rightWidth: aMargin,
        topHeight: aMargin,
        bottomHeight: aMargin,
    });
    
    return sprite;
}

export const get9Sliced = function(aName, aPart, aIndex = 0, aLeft = 5, aTop = 5, aRight = 5, aBottom = 5) {
    let texture = getTextures(aName, aPart)[aIndex];
    let sprite = new PIXI.NineSliceSprite({
        texture,
        leftWidth: aLeft,
        rightWidth: aRight,
        topHeight: aTop,
        bottomHeight: aBottom,
    });
    
    return sprite;
}

export const setupAssets = function() {

    {
        let currentObject = createAssetObject("screens/start");
        currentObject.addSingleImage("logo");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/select-character");
        currentObject.addAnimation("character", 1, 5);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("sounds/music");
        currentObject.addSoundFile("background");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("sounds/interface");
        currentObject.addSoundFile("start");
        currentObject.addSoundFile("click-coin");
        currentObject.addSoundFile("click-beep");
        currentObject.addSoundFile("hit-table");
        currentObject.addSoundFile("computer-beep");
        currentObject.addSoundFile("zoom");
        currentObject.addSoundFile("level-completed");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("sounds/game");
        currentObject.addSoundFile("jump");
        currentObject.addSoundFile("jump2");
        currentObject.addSoundFile("collect-coin");
        currentObject.addSoundFile("foot-steps-grass");
        currentObject.addSoundFile("heal");
        currentObject.addSoundFile("lose-life");
        currentObject.addSoundFile("gameover");
        currentObject.addSoundFile("explosion");
        currentObject.addSoundFile("miss");
        currentObject.addSoundFile("milk-splash");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/background");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/map");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/level-line");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/level-preview-bubble");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/level-preview");
        currentObject.addAnimation("level", 1, 8);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/button");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/button-orange");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/frame");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/reflection-mask");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/computer-window");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("game-buttons");
        currentObject.addSingleImage("jump");
        currentObject.addSingleImage("throw");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/gameover");
        currentObject.addSingleImage("background");
        currentObject.addAnimation("table", 1, 2);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/gameover/papers");
        currentObject.addAnimation("layer", 1, 8);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/gameover/poster");
        currentObject.addSingleImage("red-tape");
        currentObject.addSingleImage("milk");
        currentObject.addSingleImage("computer");
        currentObject.addSingleImage("log");
        currentObject.addSingleImage("stone");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("screens/level-completed");
        currentObject.addSingleImage("background");

        currentObject.load();
    }
    
    {
        let currentObject = createAssetObject("characters/test");
        currentObject.addAnimation("walk", 1, 12);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("characters/affe");
        currentObject.addAnimation("walk", 1, 12);
        currentObject.addAnimation("layer", 3, 7);
        currentObject.addSingleImage("jump");
        currentObject.addSingleImage("layer-01");
        currentObject.addSingleImage("layer-02");
        currentObject.addSingleImage("layer-02-open");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("characters/svenne");
        currentObject.addAnimation("layer", 3, 9);
        currentObject.addAnimation("board", 1, 6);
        currentObject.addAnimation("board-flip", 1, 4);
        currentObject.addSingleImage("jump");
        currentObject.addSingleImage("layer-01");
        currentObject.addSingleImage("layer-02");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("characters/saga");
        currentObject.addAnimation("layer", 4, 8);
        currentObject.addAnimation("walk", 1, 12);
        currentObject.addSingleImage("jump");
        currentObject.addSingleImage("layer-01");
        currentObject.addSingleImage("layer-02");
        currentObject.addSingleImage("layer-03");
        currentObject.addSingleImage("layer-03-open");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("characters/ninni");
        currentObject.addAnimation("layer", 3, 6);
        currentObject.addAnimation("walk", 1, 12);
        currentObject.addSingleImage("layer-01");
        currentObject.addSingleImage("layer-02");
        currentObject.addSingleImage("layer-02-open");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("characters/theo");
        currentObject.addAnimation("layer", 3, 5);
        currentObject.addAnimation("walk", 1, 12);
        currentObject.addSingleImage("layer-01");
        currentObject.addSingleImage("layer-02");
        currentObject.addSingleImage("layer-02-open");
        currentObject.addSingleImage("jump");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("enemies/stone");
        currentObject.addSingleImage("stone");
        currentObject.addAnimation("animation", 2, 3);
        currentObject.addSingleImage("part");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("enemies/red-tape");
        currentObject.addSingleImage("red-tape");
        currentObject.addSingleImage("part");
        currentObject.addSingleImage("eye");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("enemies/log");
        currentObject.addSingleImage("log");
        currentObject.addAnimation("animation", 1, 4);
        currentObject.addSingleImage("part");

        currentObject.load();
    }

    /*
    {
        let currentObject = createAssetObject("enemies/dog");
        currentObject.addSingleImage("dog");
        currentObject.addSingleImage("part");
        currentObject.addSingleImage("eyes");

        currentObject.load();
    }
    */

    {
        let currentObject = createAssetObject("enemies/computer");
        currentObject.addSingleImage("computer");
        currentObject.addSingleImage("part");
        currentObject.addSingleImage("spinning-ball");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("enemies/milk");
        currentObject.addSingleImage("milk");
        currentObject.addAnimation("animation", 1, 12);
        currentObject.addSingleImage("part-left");
        currentObject.addSingleImage("part-right");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("enemies/boss");
        currentObject.addAnimation("layer", 1, 5);
        currentObject.addAnimation("walk", 1, 6);
        currentObject.addSingleImage("full");
        currentObject.addSingleImage("layer-01-stamp");
        currentObject.addSingleImage("layer-01-stamp-down");
        currentObject.addSingleImage("layer-04-throw");
        currentObject.addSingleImage("overlay-stamp-down");
        currentObject.addSingleImage("no-chair");
        currentObject.addSingleImage("wheel");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("enemies/airplane");
        currentObject.addSingleImage("airplane");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("backgrounds/dark-sky");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("backgrounds/light-sky");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("backgrounds/pink-sky");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("backgrounds/sea-sky");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("backgrounds/sunset");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("backgrounds/midnight");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("fence");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("dalahorse");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("tree");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("hotel");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("snowy-tree");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("maypole");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("fox");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("horizon/forrest");
        currentObject.addAnimation("layer", 1, 3);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("horizon/field");
        currentObject.addAnimation("layer", 1, 1);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("horizon/grass-field");
        currentObject.addAnimation("layer", 1, 1);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("horizon/snowy-mountain");
        currentObject.addAnimation("layer", 1, 6);
        currentObject.addAnimation("water-layer", 1, 4);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("horizon/harbour");
        currentObject.addAnimation("layer", 1, 5);
        currentObject.addAnimation("water-layer", 1, 4);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("horizon/city");
        currentObject.addAnimation("layer", 1, 4);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("horizon/night");
        currentObject.addAnimation("layer", 1, 4);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("horizon/treeline");
        currentObject.addAnimation("tree", 1, 8);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("ground/grass");
        currentObject.addSingleImage("grass");
        currentObject.addSingleImage("dirt");
        currentObject.addSingleImage("back");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("ground/harbour");
        currentObject.addSingleImage("harbour");
        currentObject.addSingleImage("water");
        currentObject.addSingleImage("items");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("ground/street");
        currentObject.addSingleImage("wall");
        currentObject.addSingleImage("street");
        currentObject.addSingleImage("front");
        currentObject.addSingleImage("ground");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("ground/snow");
        currentObject.addSingleImage("snow");
        currentObject.addAnimation("back", 1, 3);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/coin");
        currentObject.addAnimation("coin", 1, 4);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/heart");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/dynamite");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/phone");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/ball-bearings");
        currentObject.addSingleImage("main");
        currentObject.addAnimation("animation", 1, 11);
        currentObject.addSingleImage("ball");
        currentObject.addSingleImage("ring");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/milk-bottle");
        currentObject.addSingleImage("main");
        currentObject.addSingleImage("drop");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/notes");
        currentObject.addAnimation("single-note", 1, 4);
        currentObject.addAnimation("double-note", 1, 4);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/cd");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/snail");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/seagull");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/boat");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/oak");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/fastfood");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/paper-ball");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/level-up-sign");
        currentObject.addRootImage();

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/speech");
        currentObject.addSingleImage("right");
        currentObject.addSingleImage("left");

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("effects/blink/yellow");
        currentObject.addAnimation("blink", 0, 4);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("effects/blink/white");
        currentObject.addAnimation("blink", 0, 4);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("effects/explosion");
        currentObject.addAnimation("animation", 1, 8);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("effects/ecommerce");
        currentObject.addAnimation("rise", 1, 4);
        currentObject.addAnimation("up-arrow", 0, 7);
        currentObject.addAnimation("down-arrow", 0, 7);

        currentObject.load();
    }

    {
        let currentObject = createAssetObject("objects/sign");
        currentObject.addAnimation("step-0", 0, 3);
        currentObject.addAnimation("step-1", 0, 3);
        currentObject.addAnimation("step-2", 0, 3);
        currentObject.addAnimation("step-3", 0, 3);
        currentObject.addAnimation("step-4", 0, 3);
        currentObject.addAnimation("step-5", 0, 3);
        currentObject.addAnimation("step-6", 0, 3);
        currentObject.addAnimation("step-7", 0, 3);
        currentObject.addAnimation("step-8", 0, 3);
        currentObject.addAnimation("step-9", 0, 3);
        currentObject.addSingleImage("step-long");

        currentObject.load();
    }
    
}